import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'mds-ui/environments/environment';
import { catchError } from 'rxjs/operators';
import { ParticipantsSearch, ParticipantVO, ParticipantResponse } from '../models/roles.model';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
@Injectable()
export class ParticipantsService {
    dtformat = new DateTimeFormatPipe("en-US");
    public paricipantSearch: ParticipantsSearch;
    public participants: ParticipantVO;
    public url: Array<string> = new Array<string>();
    participantsList: any = [];
    constructor(private _http: HttpClient) {
    }
    private httpOptions = {};
    getAllParticipants(username: string): Observable<ParticipantResponse[]> {
        return this._http.get<ParticipantResponse[]>(
            environment.participantsURL + "?username=" + username + "&dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(catchError(error => { return throwError(error); }));
    }
    getUrl(url: string) {
        if (url.toUpperCase().includes("?")) {
            let b = [];
            b = url.split("?");
            return b[0];
        } else {
            return url;
        }
    }

}